import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getKey } from "../../../../../shared/utils/tabsUtils";
import { usePermission } from "../../../../../shared/hooks/usePermission";
import { openInNewTab } from "../../../../../shared/utils/utils";
import ScrollLTR from "../../../../../shared/components/ui/scrollLTR/ScrollLTR";
import Popup from "../../../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import ContentsPopup from "../../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import FooterPopup from "../../../../../shared/components/ui/popup/footerPopup.js/FooterPopup";
import PrimaryBtn from "../../../../../shared/components/ui/buttons/PrimaryBtn";
import CreateStudyGroupCard from "./createStudyGroupCard/CreateStudyGroupCard";
import downloadIcon from "../../../../../assests/icons/download.svg";
import classes from "./ChooseStudyGroupPopup.module.css";

const ChooseStudyGroupPopup = ({ onClose, onSelectGroup }) => {

    const { user, userDetails, isStudent } = useSelector((state) => state.auth);
    const { texts, lang } = useSelector((state) => state.translate);
    const { platforms, general } = useSelector((state) => state.uiData);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [studyGroups, setStudyGroups] = useState([]);
    const hasPermission = usePermission();

    useEffect(() => {
        const filtered = platforms?.filter((p) => p?.data?.createCourseData && (!p.data?.createCourseData?.permission || hasPermission(getKey(p.key))))
        const studyGroupsFilterd = filtered.map((p) => ({
            key: p.key,
            name: p.text,
            imageUrl: p?.data?.createCourseData?.imageUrl || p.icon,
            link: p?.data?.createCourseData?.link || p.link,
            flow: p?.data?.createCourseData?.flow,
            entityField: p?.entityField,
            showErrorPdf: p?.showErrorPdf,
        }));

        setStudyGroups(studyGroupsFilterd);
    }, [platforms, user, userDetails, isStudent, lang])


    const handleApprove = () => {
        if (selectedGroup)
            onSelectGroup && onSelectGroup(selectedGroup);
    };

    const openPdf = () => openInNewTab(general?.downloadPageInCreateStudyGroup);

    return (
        <Popup close={onClose} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose} title={texts.openStudyGroup}>
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.openStudyGroup}</p>
            </HeaderPopup>

            <ContentsPopup className={classes.Content}>
                <p className={classes.Text}>{texts.withStudyGroupDoYouWantToOpenForYourStudents}</p>
                <ScrollLTR height={"326px"} dropClass={classes.OptionsScroll}>
                    <div className={classes.OptionsList}>
                        {studyGroups?.map((group) => (
                            <CreateStudyGroupCard
                                key={group.key}
                                group={group}
                                lang={lang}
                                onClick={() => setSelectedGroup(group)}
                                isSelected={selectedGroup?.key === group?.key}
                            />
                        ))}
                    </div>
                </ScrollLTR>
            </ContentsPopup>
            <FooterPopup
                onClose={onClose}
                next={handleApprove}
                disabled={!selectedGroup}
                className={classes.FooterAbsolute}
            >
                <PrimaryBtn dropClass={classes.BtnDownload} onClick={openPdf}>
                    <img src={downloadIcon} alt="" />
                    {texts.solutionInCreateStudyGroup}
                </PrimaryBtn>
            </FooterPopup>
        </Popup>
    )
}
export default ChooseStudyGroupPopup;
